module.exports = __webpack_public_path__ + "img/night.74a8f7fc.jpg";